<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      class="paddingBottomNone"
      maxwidth-container="820px"
    >
      <v-breadcrumbs
        v-if="$vuetify.breakpoint.mdAndUp"
        :items="menus"
        class="pl-0 mt-6"
      >
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.href"
            :disabled="item.disabled"
            class="body-2"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>

      <SolicitacaoTimeline
        :codigo-reembolso="getCodigoReembolsoFromUrl"
        :codigo-venda="getCodigoVendaFromUrl"
      />
    </InternaMain>
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import SolicitacaoTimeline from '@/components/AcompanharSolicitacao/SolicitacaoTimeline.vue';

export default {
  name: 'AcompanharReembolso',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    SolicitacaoTimeline,
  },

  data() {
    return {
      menus: [
        {
          text: 'Minhas Compras',
          disabled: false,
          href: '/minhas-compras/',
        },
        {
          text: 'Acompanhar solicitação',
          disabled: true,
        },
      ],
    };
  },

  computed: {
    getCodigoReembolsoFromUrl() {
      return parseInt(this.$route.params.codigo_reembolso, 10);
    },

    getCodigoVendaFromUrl() {
      return parseInt(this.$route.params.codigo_venda, 10);
    },
  },

};
</script>

<style lang="scss">
  .paddingBottomNone{
    padding-bottom: 0!important
  }
</style>
